import { render, staticRenderFns } from "./CotacaoAposRelatorio.vue?vue&type=template&id=5dd4926f"
import script from "./CotacaoAposRelatorio.vue?vue&type=script&lang=js"
export * from "./CotacaoAposRelatorio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports